import { render, staticRenderFns } from "./cooperationList.vue?vue&type=template&id=f3160f4e&scoped=true&"
import script from "./cooperationList.vue?vue&type=script&lang=js&"
export * from "./cooperationList.vue?vue&type=script&lang=js&"
import style0 from "./cooperationList.vue?vue&type=style&index=0&id=f3160f4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3160f4e",
  null
  
)

export default component.exports